<template>
    <div class="main-services grey-bg pt-120 pb-90" :style="{backgroundImage:'url(' + require('../../assets/img/pattern/pt1.png') +')'}">
           <div class="container">
              <div class="row mb-60">
                 <div class="col-12">
                    <div class="sec-wrapper text-center">
                       <h2 class="section-title">FALEMINDERIT</h2>
                    </div>
                 </div>
              </div>
              <div class="row text-center">
                 <div v-for="service in servicesData" :key="service.id" class="col-xl-12 col-lg-12 col-md-12 mb-30">
                    <div class="mfbox mfbox-white">
                       <div class="mf-shape"></div>
                       <div class="mfbox__icon mb-15">
                          <i :class="service.icon"></i>
                       </div>
                       <div class="mfbox__text">
                          <h3 class="mf-title" v-html="service.title"></h3>
                          <div>
                          <p>Antarësimi juaj është procesuar.</p>
                          <p>Ne do të përgatisim Kartelen dhe do ta sjellim në adresen tuaj brenda 48 ore.</p>
                          <p>Fatura është gjeneruar te downloads në paisjen tuaj.</p>
                          <p>Gjithashtu në e-mail tuaj tashmë keni pranuar faturen.</p>
                          <p>Ne punojmë vazhdimisht për të përmirësuar përvojën tuaj me ne për të siguruar që të përmbushim dhe tejkalojmë pritjet tuaja.</p>
                          <p>Ju lutemi të na kontaktoni në çdo kohë për çdo pyetje ose kërkesë që keni në 046100011.</p>
                          <p>Jemi këtu për ju!</p>
                          </div>

                          <!-- uPay online payment button (JS SDK) -->
                          <div v-if="invoiceNo && amount" class="upay-payment-section mt-30">
                             <p class="upay-hint"><strong>Dëshironi të paguani online tani?</strong></p>
                             <div id="upaybutton"></div>
                          </div>

                       </div>
                       <div class="mf-btn">
                          <router-link class="squire-btn" to="/">
                             <i class="fal fa-angle-right"></i>
                          </router-link>
                       </div>
                    </div>
                 </div>
              </div>
           </div>
        </div>
</template>

<script>
export default {
   name: 'ThankYou',
   data() {
     return {
        invoiceNo: null,
        amount: null,
        servicesData: [
           {
              id: '1',
              icon: 'flaticon-award',
              title: 'Ju keni dërguar me sukses të dhënat për anëtarësim tek Asistenca'
           },
        ]
     }
   },
   beforeCreate() {
     if (this.$route.query.success != 'true') {
       this.$router.push('/')
     }
   },
   created() {
     this.invoiceNo = this.$route.query.invoiceNo || null;
     this.amount = this.$route.query.amount ? parseFloat(this.$route.query.amount) : null;
   },
   mounted() {
     if (!this.invoiceNo || !this.amount) return;
     // Persist invoiceNo so PaymentResult page can read it after uPay redirect
     sessionStorage.setItem('upay_invoiceNo', this.invoiceNo);
     // Dynamically load the uPay JS SDK then initialise the payment button
     const script = document.createElement('script');
     script.src = 'https://cdn.upay.al/ecommerce/v1/lib.js?id=2b65cd86-7a19-43d2-a614-b093d240cb89';
     script.onload = () => {
       if (window.UPay && document.getElementById('upaybutton')) {
         window.UPay.init(this.amount, this.invoiceNo, 'upaybutton');
       }
     };
     document.head.appendChild(script);
   },
   methods: {}
}
</script>
<style scoped>
.p-text-left {
    text-align: left !important;
}
.upay-payment-section {
    margin-top: 24px;
    padding: 20px;
    background: #f0f7ff;
    border-radius: 8px;
    border: 1px solid #c8e1ff;
}
.upay-hint {
    margin-bottom: 14px;
    color: #333;
}
</style>